import React from 'react'
import Main from '../../Main'
import image from '../../../assets/img/sponsorship.jpg'

const styles = {
  fontSize: '50px'
}

const FiveHundred = () => (
  <Main>
    <div className="island">
      <h1 style={styles}><img className="img-thumbnail img-rounded" src={image} alt="2 children" /> There has been an error.</h1>
    </div>
  </Main>
)

export default FiveHundred